/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CalcolaOreCommesseResponseDTO
 */
export interface CalcolaOreCommesseResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof CalcolaOreCommesseResponseDTO
     */
    descrizione?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CalcolaOreCommesseResponseDTO
     */
    valore?: number;
}

/**
 * Check if a given object implements the CalcolaOreCommesseResponseDTO interface.
 */
export function instanceOfCalcolaOreCommesseResponseDTO(value: object): value is CalcolaOreCommesseResponseDTO {
    return true;
}

export function CalcolaOreCommesseResponseDTOFromJSON(json: any): CalcolaOreCommesseResponseDTO {
    return CalcolaOreCommesseResponseDTOFromJSONTyped(json, false);
}

export function CalcolaOreCommesseResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalcolaOreCommesseResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
        'valore': json['valore'] == null ? undefined : json['valore'],
    };
}

export function CalcolaOreCommesseResponseDTOToJSON(json: any): CalcolaOreCommesseResponseDTO {
    return CalcolaOreCommesseResponseDTOToJSONTyped(json, false);
}

export function CalcolaOreCommesseResponseDTOToJSONTyped(value?: CalcolaOreCommesseResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'descrizione': value['descrizione'],
        'valore': value['valore'],
    };
}

